import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import GroupIcon from "@mui/icons-material/Group";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import OfflinePinRoundedIcon from '@mui/icons-material/OfflinePinRounded';
import SettingsIcon from "@mui/icons-material/Settings";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import PaymentsIcon from "@mui/icons-material/Payments";
import { routes } from "../routes";

export const menuItems = [
  {
    id: "dashboard",
    title: "Dashboard",
    type: "item",
    link: routes.DASHBOARD,
    icon: <DashboardOutlinedIcon sx={{ fontSize: "20px" }} />,
  },
  {
    id: "users",
    title: "Users",
    type: "item",
    link: routes.USERS,
    icon: <GroupIcon sx={{ fontSize: "20px" }} />,
  },
  {
    id: "Advisors",
    title: "Advisors",
    type: "item",
    link: routes.ADVISORS,
    icon: <SupervisorAccountIcon sx={{ fontSize: "20px" }} />,
  },
  {
    id: "TOPICS",
    title: "Topics",
    type: "item",
    link: routes.TOPICS,
    icon: <LocalOfferIcon sx={{ fontSize: "20px" }} />,
  },
  {
    id: "validateTopics",
    title: "Validate Topics",
    type: "item",
    link: routes.VALIDATETOPICS,
    icon: <OfflinePinRoundedIcon sx={{ fontSize: "20px" }} />,
  },
  {
    id: "Transactions",
    title: "Transactions",
    type: "item",
    link: routes.TRANSACTIONS,
    icon: <PaymentsIcon sx={{ fontSize: "20px" }} />,
  },
  {
    id: "globalsettings",
    title: "Global Settings",
    type: "item",
    link: routes.SETTINGS,
    icon: <SettingsIcon sx={{ fontSize: "20px" }} />,
  },
  {
    id: "report",
    title: "Report An Issue",
    type: "item",
    link: routes.REPORT_ISSUE,
    icon: <ReportProblemIcon sx={{ fontSize: "20px" }} />,
  },
];

